export default {_name:'Text.Simple',module:'Field',view:'Element/Text',options:{color:'textPrimary',xs:12,ms:12}}